import AbstractMain from 'frontools/abstract/AbstractMain';
import Breakpoint from 'frontools/core/Breakpoint';
import { GameManager } from './core/GameManager';
import { Home } from './pages/Home';
import { Form } from './pages/Form';
import { Youppi } from "sources/js/pages/Youppi";
import Context from 'frontools/core/Context';
import Brightness from './components/Brightness';
import Facebook from 'frontools/social/Facebook';
import { autobind } from 'node_modules/frontools/decorators/Autobind';

export class Main extends AbstractMain {

    public breakpoint               : Breakpoint;
    public _gameManager             : GameManager;
    
    private _isForm                 : Boolean       = false

    constructor(context:Object = {}) {
        super(context);
        const body = document.querySelector('body');

        if(body.classList.contains('event_form')) {
            new Form();
            // document.addEventListener('touchmove',(e) => {
            //     e.preventDefault();
            // });
        } else if(body.classList.contains('event_list')) {
            // document.addEventListener('touchmove',(e) => {
            //     e.preventDefault();
            // });
            
            var links:NodeListOf<HTMLElement> =  document.querySelectorAll('a');
            
            if((window.navigator as any).standalone == true) {
                // make all link remain in web app mode.
                for(var i:number =0; i <links.length; i++) {
                    console.log(links[i]);
                    (links[i] as HTMLElement).onclick = function(e) {
                        e.preventDefault();
                        var target:HTMLElement = e.currentTarget as HTMLElement;
                        
                        window.location.href = target.getAttribute('href');
                    }
                }
            }
        } else {
            this._gameManager = new GameManager();

            if (body.classList.contains('p_home')) {
                new Home();
            } else if (body.classList.contains('p_youppi')) {
                new Youppi();
            } else if (body.classList.contains('p_blackmonday')) {
                const btShare = document.querySelector('.js_facebook');
                btShare.addEventListener('click', () => { Facebook.sharer(window.location.href, true) });
            } 
            
            const brightness = [].slice.call(document.querySelectorAll('.js_brightness'));
            brightness.forEach(element => {
                const pos = body.classList.contains('p_home') ?
                    0 : 100;
                new Brightness(element as HTMLElement, pos);
            });

            
            Breakpoint.trigger();

            if (Context.getInstance().isIPad()) {
                var elSitesMenu = document.querySelector('.header_main .nav_item_wrapper') as HTMLElement;
                if (elSitesMenu) elSitesMenu.style.display = 'none';
            }
        }
        
 
    }

}